import React from "react";
import { Link, graphql, StaticQuery } from "gatsby";
import Logo from "../vectors/escriptLogo";
import Headroom from "react-headroom";
import Pill from "../vectors/pill";
import VectorSupport from "../../assets/support.svg";

class PageHeader extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };
  }

  toggleMobile = () => {
    const bodyClasses = document.getElementsByTagName("body")[0].classList;

    // Freazing the scroll
    if (!this.state.isOpen) {
      bodyClasses.add("is-locked");
    } else {
      bodyClasses.remove("is-locked");
    }

    this.setState({
      isOpen: !this.state.isOpen,
    });
  };

  closeMobile = () => {
    const bodyClasses = document.getElementsByTagName("body")[0].classList;

    bodyClasses.remove("is-locked");

    this.setState({ isOpen: false });
  };

  OpenLogin = (e) => {
    e.preventDefault()
    const loginOverflow = document.getElementsByClassName("login_overflow")[0];
    loginOverflow.classList.add("active");
  }

  CloseLogin = () => {
    const loginOverflow = document.getElementsByClassName("login_overflow")[0];
    loginOverflow.classList.remove("active");
  }

  render() {
    const doc = this.props.data.prismic.allHeaders.edges.slice(0, 1).pop();
    const data = this.props.data.prismic.allHeaders.edges[0];

    if (!doc || !data) return null;

    return (
      <div
        className={this.state.isOpen ? "page-header is-open" : "page-header"}
      >
        <Headroom
          className="page-header__headroom"
          disableInlineStyles
          pinStart={160}
        >
          <div className="page-header__inner">
            <Link
              to="/"
              className="page-header__logo"
              onClick={this.closeMobile}
            >
              <Logo fill="#00B4D7" />
            </Link>

            <div className="page-header__content">
              <div className="page-header__topper">
                <ul className="page-header__tertiary">
                  <li>
                    <a href="/join-us/#contact">Support</a>
                  </li>
                  <li>
                    <a href="/" onClick={this.OpenLogin}>Log In</a>
                  </li>
                </ul>
              </div>

              <ul className="page-header__list">
                {data.node.navigation_links.map((nav, index) => {
                  return (
                    <li key={index}>
                      <Link to={nav.link} activeClassName="is-active">
                        {nav.title}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>

            <button
              className="page-header__hamburger"
              onClick={this.toggleMobile}
            >
              <span></span>
            </button>
          </div>
        </Headroom>

        <div className="mobile-nav">
          <div className="mobile-nav__scrim" onClick={this.closeMobile}></div>

          <div className="mobile-nav__pane">
            <div className="mobile-nav__topper">
              <ul className="mobile-nav__login">
                <li>
                  <a href="/" onClick={this.OpenLogin}>Log In</a>
                </li>
              </ul>

              <Link
                to={data.node.support_link}
                state={{ path: data.node.support_link }}
                onClick={this.toggleMobile}
                className="mobile-nav__support"
              >
                <VectorSupport />
                <span>{data.node.support_title}</span>
              </Link>
            </div>

            <div className="mobile-nav__content">
              <ul className="mobile-nav__list">
                <li>
                  <Link
                    to="/"
                    activeClassName="is-active"
                    onClick={this.toggleMobile}
                  >
                    Home
                  </Link>
                </li>

                {data.node.navigation_links.map((nav, index) => {
                  return (
                    <li key={index}>
                      <Link
                        to={nav.link}
                        activeClassName="is-active"
                        onClick={this.toggleMobile}
                      >
                        {nav.title}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>

        <div className="login_overflow">
          <div id="closeBtn" onClick={this.CloseLogin}>
            <svg viewBox="0 0 329.26933 329" xmlns="http://www.w3.org/2000/svg">
              <path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0" fill="#fff"></path>
            </svg>
          </div>
          <div className="modal">
            <Pill fill="#4b328c" className="pill1" />
            <Pill fill="#ffffff" className="circular pill2" />
            <Pill fill="#ffffff" className="pill3" />
            <Pill fill="#4b328c" className="circular pill4" />
            <Pill fill="#ffffff" className="pill5" />
            <Pill fill="#ffffff" className="circular pill6" />
            <div className="content">
              <div className="left_side">
                <div className="wel_title">Welcome</div>
                <img alt="" src="https://images.prismic.io/escript360/e03ba303-91f8-4581-a066-75f35968e1c2_Picture1.png" />
                <Logo fill="#fff" />
              </div>
              <form className="right_side">
                <label className="email_log">
                  Email
                  <input type="text" />
                </label>
                <label className="password_log">
                  Password
                  <input type="password" />
                </label>
                <a href="/">Forgot your password?</a>
                <button className="button button--primary">
                  Sign In
                </button>
                <span>New here? <a href="#+/">Create an account</a></span>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default (props) => (
  <StaticQuery
    query={graphql`
      {
        site {
          siteMetadata {
            loginUrl
            getStartedUrl
          }
        }
        prismic {
          allHeaders {
            edges {
              node {
                support_title
                support_link
                log_in_link
                get_started_link
                navigation_links {
                  title
                  link
                }
                login_links {
                  title
                  link
                }
                link_to_med_finder {
                  ... on PRISMIC_Med_finder {
                    _meta {
                      uid
                    }
                  }
                }
              }
            }
          }
        }
      }
    `}
    render={(data) => <PageHeader data={data} {...props} />}
  />
);
